import { Observable } from 'rxjs';
import { ExtensionBroker } from './extension-broker/extension-broker';

export class ColumnPickerDialogResponse {
    confirmed: boolean;
    parameters: ColumnPickerDialogResponseParameters;
}

export class ColumnPickerDialogResponseParameters {
    chooseColumnData: any;
    groupByColumnData: any;
}

export interface DataTableColumn {
    field: string;
    header: string;
    hidden: boolean;
    queryEditorType: string;
    searchable: boolean;
    sortMode: number;
    sortable: string;
}
/**
 * Creates a new column picker dialog extension service
 */
export class ColumnPicker {
    /**
     * Instantiates a new column picker dialog service
     * @param extensionBroker The extension broker service
     */
    constructor(private extensionBroker: ExtensionBroker) { }

    public show(dataTableAllColumns: Array<DataTableColumn>, columnPickerDialogData: ColumnPickerDialogResponseParameters): Observable<ColumnPickerDialogResponse> {
        return this.extensionBroker.showDialog('msft.sme.shell-extensions!columnPickerDialog', 0, dataTableAllColumns,
            columnPickerDialogData);
    }

}
